(function () {
  /* POJAWIANIE BLOKOW PRZY SCROLLU

     Stan domyslny sekcji to WIDOCZNE. Skrypt najpierw oznacza sekcje klasa
     aio6--js i dopiero ta klasa wlacza w arkuszu stan poczatkowy
     (przezroczyste, zsuniete o 16px). Kolejnosc jest wazna: gdy JavaScript
     jest wylaczony, gdy skrypt sie wywali albo gdy przegladarka nie zna
     IntersectionObservera, klasa nigdy nie wchodzi i cala tresc po prostu
     stoi na swoim miejscu.

     Idempotencja idzie po klasie na elemencie sekcji, nie po fladze globalnej:
     dwa egzemplarze sekcji na stronie inicjuja sie osobno, a przeladowanie
     sekcji w edytorze motywu dostaje swiezy DOM bez klasy i rusza od nowa.
     Flaga globalna pilnuje wylacznie nasluchu na dokumencie, zeby po kilku
     przeladowaniach nie zrobilo sie z niego kilka kopii. */
  var READY = 'aio6--js';
  var SEEN = 'is-in';

  /* WIDEO
     Petle graja zawsze, z jednym wyjatkiem: na telefonie (ponizej
     769px) przy wlaczonym ograniczeniu ruchu kino zostaje na posterze i nie
     startuje samo - film jest tam pelnoekranowy i ruch zajmuje caly kadr.
     Od 769px ograniczenie ruchu wycisza tylko pojawianie blokow przy scrollu
     (arkusz sekcji), a nie tresc, ktora jest materialem produktowym.

     Zaden CSS nie chowa tu wideo - ani na chwile, ani pod zadna kwerenda.

     muted ustawiamy WLASCIWOSCIA, bo Safari czyta wyciszenie stamtad, nie z
     atrybutu, i bez tego potrafi nie wystartowac. play() zwraca obietnice,
     ktora przegladarka odrzuca, gdy uzna, ze nie wolno grac - to jej decyzja,
     nie blad, wiec ja przechwytujemy, zeby konsola zostala czysta. */
  function media(scope) {
    /* Klipy z wlasnym przyciskiem (data-aio6-clip) stoja z zalozenia i nie
       maja klasy .aio6__video, wiec ta petla ich nie dotyka. */
    var videos = scope.querySelectorAll('.aio6__video, [data-aio6-loop]');
    for (var i = 0; i < videos.length; i++) {
      var video = videos[i];
      /* Petla oznaczona data-aio6-loop jest ozdobna, wiec przy wlaczonym
         ograniczeniu ruchu zostaje na posterze. Petle .aio6__video to material
         produktowy i graja zawsze - patrz komentarz nad ta funkcja. */
      if (video.hasAttribute('data-aio6-loop') && reduced()) continue;
      /* Kino kamer na telefonie nie jest osadzane (nieruchomy kadr
         i nagranie w dialogu) - nie dotykamy go, zeby nie pobrac pliku. Od
         769px dopiero tu dostaje preload metadata. */
      if (video.closest('.aio6__cinema--still')) {
        if (telefon()) continue;
        if (video.preload === 'none') video.preload = 'metadata';
      }
      video.muted = true;
      if (reduced() && telefon()) {
        video.removeAttribute('autoplay');
        if (!video.paused) video.pause();
        continue;
      }
      if (!video.paused) continue;
      var started = video.play();
      if (started && started.catch) started.catch(function () {});
    }
  }

  /* PRZECIAGANIE TORU MYSZA

     Palcem tory przewijaja sie natywnie i tego nie ruszamy - ten kod dotyczy
     wylacznie myszy (pointerType === 'mouse'), bo tam natywnego przewijania
     w poziomie nie ma.

     Snap wylaczamy tylko na czas ciagniecia: po puszczeniu wraca i tor sam
     dojezdza do krawedzi kafla. Po przeciagnieciu dluzszym niz prog kasujemy
     najblizsze klikniecie w fazie przechwytywania - inaczej puszczenie palca
     nad kafelkiem otwieraloby link albo uruchamialo film. */
  function drag(scope) {
    var tory = [].slice.call(scope.querySelectorAll('.aio6__tiles, [data-aio6-track]'));
    var PROG = 6;
    /* Przerwa (ms) miedzy zdarzeniami wheel, po ktorej zaczyna sie nowy
       gest - dluzsza niz odstep zdarzen bezwladnosci gladzika (ok. 16 ms),
       krotsza niz swiadoma zmiana kierunku. Linia przy deltaMode 1: 16 px. */
    var OS_PRZERWA = 200;
    var LINIA = 16;

    for (var i = 0; i < tory.length; i++) {
      (function (tor) {
        if (tor.getAttribute('data-aio6-drag') === 'on') return;
        tor.setAttribute('data-aio6-drag', 'on');

        var ciagnie = false;
        var przechwyt = false;
        var startX = 0;
        var startScroll = 0;
        var przesuniecie = 0;

        tor.addEventListener('pointerdown', function (event) {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          /* Nacisk na przycisk filmu nie zaczyna przeciagania.
             Przechwycenie wskaznika (nizej) kieruje pointerup i click do toru,
             wiec klikniecie mysza nie docieralo do przycisku i film nie
             ruszal. Palca to nie dotyczy - dla dotyku wyszlismy linie wyzej. */
          if (event.target.closest && event.target.closest('[data-aio6-clip-btn]')) return;
          ciagnie = true;
          przesuniecie = 0;
          startX = event.clientX;
          startScroll = tor.scrollLeft;
        });

        /* Wskaznik przechwytujemy dopiero, gdy ruch przekroczy PROG.
           Zwykle klikniecie mysza (odnosnik przypisu w kaflu, przycisk karty
           przegladu) trafia wtedy do swojego celu, a nie do toru. */
        tor.addEventListener('pointermove', function (event) {
          if (!ciagnie) return;
          if (!(event.buttons & 1)) { ciagnie = false; return; }
          przesuniecie = event.clientX - startX;
          if (!przechwyt) {
            if (Math.abs(przesuniecie) <= PROG) return;
            przechwyt = true;
            tor.classList.add('is-dragging');
            try { tor.setPointerCapture(event.pointerId); } catch (blad) {}
          }
          tor.scrollLeft = startScroll - przesuniecie;
        });

        function koniec(event) {
          if (!ciagnie) return;
          ciagnie = false;
          if (przechwyt) {
            przechwyt = false;
            tor.classList.remove('is-dragging');
            try { tor.releasePointerCapture(event.pointerId); } catch (blad) {}
          }

          if (Math.abs(przesuniecie) <= PROG) return;

          /* jednorazowa blokada najblizszego klikniecia */
          tor.addEventListener('click', function zjedz(klik) {
            klik.preventDefault();
            klik.stopPropagation();
            tor.removeEventListener('click', zjedz, true);
          }, true);
        }

        tor.addEventListener('pointerup', koniec);
        tor.addEventListener('pointercancel', koniec);

        /* KOLKO MYSZY I GLADZIK W PIONIE
           Gest pionowy z niewielka skladowa pozioma (gladzik, Magic Mouse)
           przegladarka przypina do toru, bo tor umie przewinac sie w poziomie:
           strona staje, a karty drgaja. Os gestu ustalamy na pierwszym
           zdarzeniu po przerwie OS_PRZERWA; gest pionowy nie rusza toru, a strone
           przewijamy o jego deltaY. Gest poziomy i czysty pion bez skladowej
           poziomej zostaja natywne (plynne przewijanie przegladarki). */
        var os = null;
        var osCzas = -Infinity;
        var ukos = false;
        tor.addEventListener('wheel', function (event) {
          if (event.ctrlKey) return;
          if (event.timeStamp - osCzas > OS_PRZERWA) {
            os = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? 'x' : 'y';
            ukos = false;
          }
          osCzas = event.timeStamp;
          if (os !== 'y') return;
          if (event.deltaX !== 0) ukos = true;
          if (!ukos) return;
          event.preventDefault();
          var mnoznik = event.deltaMode === 1 ? LINIA : event.deltaMode === 2 ? window.innerHeight : 1;
          window.scrollBy(0, event.deltaY * mnoznik);
        }, { passive: false });
      })(tory[i]);
    }
  }

  /* WCISNIECIE TYLKO NA ELEMENTACH Z AKCJA
     :active zostaje w arkuszu (mysz, dotyk i Spacja), a ten
     kod tylko gasi wcisniecie, gdy gest okazal sie przewijaniem: ruch wskaznika
     o wiecej niz NACISK_PROG px od punktu dotkniecia,
     pointercancel albo utrata przechwytu w trakcie gestu. Atrybut
     zostaje do nastepnego nacisku albo klawisza: na iOS po pointercancel palec
     lezy dalej i :active trwa do touchend. Nasluchy tylko na elemencie sekcji,
     w fazie przechwytywania; klikniecie zostaje natywne. */
  var NACISK = '.aio6__pill, .aio6__seg-opt, .aio6__clip-btn';
  var NACISK_PROG = 10;

  function nacisk(scope) {
    if (scope.hasAttribute('data-aio6-nacisk-on')) return;
    scope.setAttribute('data-aio6-nacisk-on', '');
    var gesty = {};

    function cel(event) {
      return event.target && event.target.closest ? event.target.closest(NACISK) : null;
    }

    function przerwij(id) {
      var g = gesty[id];
      if (!g) return;
      g.el.setAttribute('data-aio6-nacisk', '');
      delete gesty[id];
    }

    scope.addEventListener('pointerdown', function (event) {
      var el = cel(event);
      if (!el || (event.pointerType === 'mouse' && event.button !== 0)) return;
      el.removeAttribute('data-aio6-nacisk');
      gesty[event.pointerId] = { el: el, x: event.clientX, y: event.clientY };
    }, true);

    scope.addEventListener('pointermove', function (event) {
      var g = gesty[event.pointerId];
      if (!g) return;
      if (event.pointerType === 'mouse' && !(event.buttons & 1)) { delete gesty[event.pointerId]; return; }
      var dx = event.clientX - g.x;
      var dy = event.clientY - g.y;
      if (dx * dx + dy * dy > NACISK_PROG * NACISK_PROG) przerwij(event.pointerId);
    }, true);

    /* pointerup przed lostpointercapture: niejawny przechwyt dotyku znika
       zaraz po puszczeniu i nie moze gasic zwyklego tapniecia */
    scope.addEventListener('pointerup', function (event) { delete gesty[event.pointerId]; }, true);
    scope.addEventListener('pointercancel', function (event) { przerwij(event.pointerId); }, true);
    scope.addEventListener('lostpointercapture', function (event) { przerwij(event.pointerId); }, true);
    scope.addEventListener('keydown', function (event) {
      var el = cel(event);
      if (el) el.removeAttribute('data-aio6-nacisk');
    }, true);
  }

  /* STOPKA PRZYPISOW NA TELEFONIE
     Ponizej 769px arkusz trzyma tresc zwinieta do 120px; skrypt przelacza
     is-open i aria-expanded. Wysokosc rozwinietej tresci trafia do
     --aio6-notes-h tylko na czas przejscia (potem none, zeby zmiana fontu albo
     szerokosci niczego nie ucinala). Po zwinieciu, gdy poczatek stopki jest nad
     oknem, widok wraca na niego. Odnosnik przypisu przy zwinietej stopce
     rozwija ja natychmiast w fazie przechwytywania klikniecia, wiec domyslny
     skok do kotwicy trafia juz w rozwinieta tresc. */
  function notes(scope) {
    var stopka = scope.querySelector('[data-aio6-notes]');
    if (!stopka || stopka.hasAttribute('data-aio6-notes-on')) return;
    stopka.setAttribute('data-aio6-notes-on', '');
    var tresc = stopka.querySelector('[data-aio6-notes-body]');
    var btn = stopka.querySelector('[data-aio6-notes-toggle]');
    if (!tresc || !btn) return;

    function otworz(bezRuchu) {
      if (bezRuchu || reduced()) {
        stopka.classList.add('is-instant');
        tresc.style.setProperty('--aio6-notes-h', 'none');
      } else {
        tresc.style.setProperty('--aio6-notes-h', tresc.scrollHeight + 'px');
      }
      stopka.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      if (bezRuchu || reduced()) {
        void tresc.offsetHeight;
        stopka.classList.remove('is-instant');
      }
    }

    function zwin() {
      tresc.style.setProperty('--aio6-notes-h', tresc.scrollHeight + 'px');
      void tresc.offsetHeight;
      stopka.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      if (stopka.getBoundingClientRect().top < 0) {
        stopka.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' });
      }
    }

    tresc.addEventListener('transitionend', function (event) {
      if (event.target === tresc && event.propertyName === 'max-height' && stopka.classList.contains('is-open')) {
        tresc.style.setProperty('--aio6-notes-h', 'none');
      }
    });

    btn.addEventListener('click', function () {
      if (stopka.classList.contains('is-open')) zwin(); else otworz(false);
    });

    scope.addEventListener('click', function (event) {
      if (!telefon() || stopka.classList.contains('is-open')) return;
      var a = event.target && event.target.closest ? event.target.closest('a[href^="#aio6-fn-"]') : null;
      if (!a) return;
      var cel = document.getElementById(a.getAttribute('href').slice(1));
      if (cel && tresc.contains(cel)) otworz(true);
    }, true);

    /* wejscie z adresem przypisu: rozwin i dosun cel, ktory przegladarka
       przewinela jeszcze pod zwinieta tresc */
    var cel = tresc.querySelector(':target');
    if (cel && telefon()) {
      otworz(true);
      cel.scrollIntoView({ block: 'start' });
    }
  }

  /* STRZALKI POD TOREM KAFLI

     Tor przewija sie palcem i gladzikiem bez skryptu; strzalki sa dodatkiem
     dla kursora i klawiatury. Jedno klikniecie to dokladnie jedna karta: cel
     to pozycja nastepnej karty z DOM (pozycje()), a nie tokeny ani
     suma szerokosci.

     Strzalka na krancu toru jest wylaczona, a nie tylko przygaszona. Stan
     odswiezamy po kazdym przewinieciu, takze recznym. */
  function tiles(scope) {
    var tory = [].slice.call(scope.querySelectorAll('[data-aio6-tiles]'));
    for (var i = 0; i < tory.length; i++) {
      (function (tor) {
        if (tor.getAttribute('data-aio6-tiles') === 'on') return;
        tor.setAttribute('data-aio6-tiles', 'on');

        /* Panel strzalek siedzi w wierszu noty pod torem, wiec nie jest juz
           rodzenstwem toru - szukamy go w obrebie tego samego bloku. */
        var blok = tor.closest('.aio6__block');
        var panel = blok ? blok.querySelector('.aio6__slides--tiles') : null;
        if (!panel) return;
        var strzalki = [].slice.call(panel.querySelectorAll('[data-aio6-tiles-arrow]'));
        if (!strzalki.length) return;

        var cel = null;
        var celCzas = 0;

        function odswiez() {
          var max = tor.scrollWidth - tor.clientWidth;
          for (var k = 0; k < strzalki.length; k++) {
            var kier = Number(strzalki[k].getAttribute('data-aio6-tiles-arrow'));
            strzalki[k].disabled = kier < 0 ? tor.scrollLeft <= 1 : tor.scrollLeft >= max - 1;
          }
        }

        for (var b = 0; b < strzalki.length; b++) {
          (function (btn) {
            btn.addEventListener('click', function () {
              var kier = Number(btn.getAttribute('data-aio6-tiles-arrow'));
              var poz = pozycje(tor);
              if (!poz.length) return;
              var baza = cel !== null && Date.now() - celCzas < RUCH_MS ? cel : najblizsza(tor, poz);
              cel = Math.max(0, Math.min(baza + kier, poz.length - 1));
              celCzas = Date.now();
              tor.scrollTo({ left: poz[cel], behavior: reduced() ? 'auto' : 'smooth' });
            });
          })(strzalki[b]);
        }

        tor.addEventListener('scroll', odswiez, { passive: true });
        window.addEventListener('resize', odswiez);
        odswiez();
      })(tory[i]);
    }
  }

  /* KINO KAMER JAKO SCENA PRZEWIJANA (od 901px)

     Skrypt liczy JEDNA liczbe: postep przewiniecia pojemnika, 0..1, i zapisuje
     ja jako --aio6-p. Cala geometria - polozenie i rozmiar wideo, krycie ramki
     i tekstu - jest policzona w arkuszu w calc() z tej jednej zmiennej. Dzieki
     temu w handlerze scrolla nie ma zadnej matematyki ukladu, a ponizej 901px
     zmienna po prostu nikogo nie obchodzi.

     Nasluch idzie na oknie, bo to okno sie przewija - to jedyne miejsce w tej
     sekcji, gdzie wychodzimy poza jej wlasne elementy. Odczyt pozycji jest
     zawsze w klatce animacji, wiec scroll nie wymusza przeliczenia ukladu.

     Nie uzywamy CSS scroll-driven animations: Safari (desktop i telefon) ma
     zachowywac sie tak samo jak reszta. */
  function parallax(scope) {
    var wrap = scope.querySelector('[data-aio6-scroll]');
    if (!wrap || wrap.getAttribute('data-aio6-scroll') === 'on') return;
    wrap.setAttribute('data-aio6-scroll', 'on');

    var video = wrap.querySelector('.aio6__cinema-video');
    var ramka = wrap.querySelector('.aio6__kino-frame');
    var scena = wrap.querySelector('.aio6__cinema');
    var czeka = false;
    var g = null;

    function szeroko() {
      return !!(window.matchMedia && window.matchMedia('(min-width: 901px)').matches);
    }

    /* Geometria stala dla danego okna: pudelko wideo, kadr poczatkowy 21:9
       i prostokat szkla w ramce (ulamki z pomiaru pliku, patrz arkusz).
       Czytamy wartosci ukladu (offset*), ktorych transform nie zmienia. */
    function mierz() {
      /* przy ograniczeniu ruchu scena stoi (arkusz) - bez transformu */
      if (!video || !ramka || !scena || !szeroko() || reduced()) { g = null; return; }
      var w0 = video.offsetWidth;
      var h0 = w0 * 9 / 21;
      g = {
        w0: w0,
        box: w0 * 9 / 16,
        r0: { x: 0, y: scena.clientHeight / 2 - h0 / 2, w: w0, h: h0 },
        r1: {
          x: ramka.offsetLeft + ramka.offsetWidth * 0.0749,
          y: ramka.offsetTop + ramka.offsetHeight * 0.190898,
          w: ramka.offsetWidth * 0.546879,
          h: ramka.offsetHeight * 0.682033
        }
      };
    }

    function licz() {
      czeka = false;
      var r = wrap.getBoundingClientRect();
      var zakres = r.height - window.innerHeight;
      var p = zakres > 0 ? -r.top / zakres : (r.top <= 0 ? 1 : 0);
      if (p < 0) p = 0;
      if (p > 1) p = 1;
      wrap.style.setProperty('--aio6-p', p.toFixed(4));

      if (!g) {
        if (video) { video.style.transform = ''; video.style.clipPath = ''; }
        return;
      }
      /* Wideo dojezdza na 60% drogi, wygladzone smoothstepem - ruch idzie
         dokladnie za przewijaniem, bez transition czasowych. */
      var q = Math.min(1, p / 0.6);
      var e = q * q * (3 - 2 * q);
      var x = g.r0.x + (g.r1.x - g.r0.x) * e;
      var y = g.r0.y + (g.r1.y - g.r0.y) * e;
      var w = g.r0.w + (g.r1.w - g.r0.w) * e;
      var h = g.r0.h + (g.r1.h - g.r0.h) * e;
      var s = w / g.w0;
      var ciecie = (g.box - h / s) / 2;
      video.style.transform = 'translate3d(' + x.toFixed(2) + 'px,' + (y - ciecie * s).toFixed(2) + 'px,0) scale(' + s.toFixed(5) + ')';
      video.style.clipPath = 'inset(' + ciecie.toFixed(2) + 'px 0)';
    }

    function zamow() {
      if (czeka) return;
      czeka = true;
      window.requestAnimationFrame(licz);
    }

    function odnow() { mierz(); zamow(); }

    window.addEventListener('scroll', zamow, { passive: true });
    window.addEventListener('resize', odnow);
    if (ramka && !ramka.complete) ramka.addEventListener('load', odnow);
    /* Zmiana "Ogranicz ruch" przy otwartej stronie. Arkusz przelacza scene
       od razu, a geometria zostawala z chwili startu: po wlaczeniu ograniczenia
       wideo stalo pomniejszone w polowie kadru zamiast w stanie poczatkowym,
       a po wylaczeniu scena przyklejala sie bez ruchu, gdy ramka byla juz
       pobrana (jedyny inny powod do ponownego pomiaru to jej zdarzenie load). */
    var mqRuch = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    if (mqRuch && mqRuch.addEventListener) mqRuch.addEventListener('change', odnow);
    else if (mqRuch && mqRuch.addListener) mqRuch.addListener(odnow);
    mierz();
    licz();
  }

  function reveal(scope) {
    if (!scope || scope.classList.contains(READY)) return;

    /* wideo obslugujemy PRZED sprawdzeniem obserwatora - decyzja o ruchu ma
       zapasc takze w przegladarce, ktora nie zna IntersectionObservera */
    media(scope);

    if (!('IntersectionObserver' in window)) return;

    var items = scope.querySelectorAll('.aio6__block');
    if (!items.length) return;

    /* WEJSCIA
       Hero (zawsze) i blok, ktory przy starcie jest w oknie albo nad nim
       (strona otwarta w polowie), dostaje is-in od razu i nigdy nie jest
       ukryty. Ponizej okna oznaczamy dzieci bloku do kaskady; stan ukryty
       wlacza dopiero klasa READY dodana PO oznaczeniu. Przy ograniczeniu
       ruchu nic nie jest oznaczane. */
    var bezRuchu = reduced();
    var czekaja = [];
    for (var n = 0; n < items.length; n++) {
      if (bezRuchu || items[n].classList.contains('aio6__hero') ||
          items[n].getBoundingClientRect().top < window.innerHeight) {
        items[n].classList.add(SEEN);
      } else {
        kaskada(items[n]);
        czekaja.push(items[n]);
      }
    }

    scope.classList.add(READY);
    if (!czekaja.length) return;

    /* Obserwator patrzy wylacznie na elementy tej sekcji - nigdy na dokument.
       Element, ktory raz wszedl, jest od razu odpinany: wejscie gra raz, a
       przewijanie w gore niczego nie chowa. Dolny margines -12% odpala wejscie
       dopiero, gdy blok jest wyraznie w oknie. */
    var watcher = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        watcher.unobserve(entries[i].target);
        wejdz(entries[i].target);
      }
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });

    for (var c = 0; c < czekaja.length; c++) {
      watcher.observe(czekaja[c]);
    }
  }

  /* Dzieci do kaskady: schodzimy przez pojedyncze opakowania (page-width,
     siatka), az trafimy na poziom z kilkoma elementami. Indeks przyciety do
     4 - piec krokow, reszta wchodzi razem z piatym. */
  function kaskada(block) {
    var pojemnik = block;
    for (var g = 0; g < 3 && pojemnik.children.length === 1; g++) {
      pojemnik = pojemnik.children[0];
    }
    var dzieci = pojemnik.children;
    for (var i = 0; i < dzieci.length; i++) {
      dzieci[i].setAttribute('data-aio6-rv', '');
      dzieci[i].style.setProperty('--aio6-i', String(Math.min(i, 4)));
    }
  }

  /* Wejscie bloku: will-change na czas animacji, potem sprzatamy atrybuty,
     zeby elementy wrocily do wlasnych przejsc. Czas = dur-slow + 4 kroki
     kaskady, odczytany z tokenow arkusza. */
  function wejdz(block) {
    block.classList.add('is-moving');
    block.classList.add(SEEN);
    media(block);
    var style = getComputedStyle(block);
    var czas = (parseFloat(style.getPropertyValue('--aio6-dur-slow')) || 620) +
      4 * (parseFloat(style.getPropertyValue('--aio6-step')) || 70);
    window.setTimeout(function () {
      block.classList.remove('is-moving');
      var rv = block.querySelectorAll('[data-aio6-rv]');
      for (var i = 0; i < rv.length; i++) {
        rv[i].removeAttribute('data-aio6-rv');
        rv[i].style.removeProperty('--aio6-i');
      }
    }, czas + 50);
  }

  /* CELE PRZEWINIECIA TOROW
     Cel to pozycja konkretnej karty (offsetLeft wzgledem pierwszej, przycieta
     do konca toru), a nie biezaca pozycja plus szerokosc karty: przy
     powiekszeniu przegladarki szerokosci sa ulamkowe, a krok liczony od pozycji
     w polowie plynnego przewijania przeskakiwal o dwie karty. Pierwsza karta
     kazdego toru stoi na pozycji 0 (wciecie = scroll-padding, a w przegladzie
     od 769px symetryczny padding centruje karte 0), wiec roznica offsetLeft
     obsluguje snap start i center. Karta biezaca to najblizsza pozycja
     (porownanie, bez dzielenia). RUCH_MS: kolejne klikniecie w tym czasie liczy
     sie od celu poprzedniego, a nie od miejsca, w ktorym tor akurat jest -
     dluzej niz plynne przewiniecie o jedna karte (ok. 500-700 ms). */
  var RUCH_MS = 1000;

  function pozycje(tor) {
    var karty = tor.children;
    var max = tor.scrollWidth - tor.clientWidth;
    var wynik = [];
    if (!karty.length) return wynik;
    var zero = karty[0].offsetLeft;
    for (var i = 0; i < karty.length; i++) {
      wynik.push(Math.max(0, Math.min(karty[i].offsetLeft - zero, max)));
    }
    return wynik;
  }

  function najblizsza(tor, poz) {
    var sl = tor.scrollLeft;
    var best = 0;
    for (var i = 1; i < poz.length; i++) {
      if (Math.abs(poz[i] - sl) < Math.abs(poz[best] - sl)) best = i;
    }
    return best;
  }

  function reduced() {
    return !!(window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* Ten sam prog, co w arkuszu: ponizej 769px kino stoi w kadrze 4:5. */
  function telefon() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 768px)').matches);
  }

  /* KARUZELA PRZEGLADU

     Przewijanie palcem i gladzikiem dziala bez skryptu - to jest stan
     podstawowy, a scroll-snap sam zatrzymuje karte na srodku. Skrypt dokłada
     trzy rzeczy: kropki odbijajace aktywna karte, skok do karty po kliknieciu
     kropki, strzalki oraz przesuniecie klikietej karty na srodek.

     Nic nie przewija sie samo - pokaz slajdow zostal usuniety, bo nikt go nie
     uruchamial. Dzieki temu nie ma tez timera ani wstrzymywania na kursorze.

     Aktywna karte wyznacza IntersectionObserver z root ustawionym na tor -
     zaden timer nie odpytuje pozycji w petli. Threshold 0.6 znaczy "karta
     zajmuje wiekszosc kadru", czyli dokladnie to, co widzi uzytkownik. */
  function carousel(scope) {
    var track = scope.querySelector('[data-aio6-track]');
    if (!track) return;

    var slides = [].slice.call(track.children);
    var dots = [].slice.call(scope.querySelectorAll('[data-aio6-dot]'));
    var arrows = [].slice.call(scope.querySelectorAll('[data-aio6-arrow]'));
    var hits = [].slice.call(track.querySelectorAll('[data-aio6-hit]'));
    if (!slides.length) return;

    var aktywny = 0;
    var cel = null;
    var celCzas = 0;

    /* Kolejne klikniecie strzalki w trakcie ruchu liczy sie od celu
       poprzedniego klikniecia (RUCH_MS), a nie od karty aktywnej w polowie drogi. */
    function baza() {
      return cel !== null && Date.now() - celCzas < RUCH_MS ? cel : aktywny;
    }

    function oznacz(i) {
      aktywny = i;
      for (var d = 0; d < dots.length; d++) {
        var czy = d === i;
        dots[d].classList.toggle('is-active', czy);
        dots[d].tabIndex = czy ? 0 : -1;
        if (czy) dots[d].setAttribute('aria-current', 'true');
        else dots[d].removeAttribute('aria-current');
      }
      /* Strzalka na skraju toru nie ma dokad prowadzic, wiec jest wylaczona,
         a nie tylko przygaszona. */
      for (var a = 0; a < arrows.length; a++) {
        var kier = Number(arrows[a].getAttribute('data-aio6-arrow'));
        arrows[a].disabled = kier < 0 ? i <= 0 : i >= slides.length - 1;
      }
    }

    /* Liczymy cel sami, zamiast wolac scrollIntoView: ten drugi przewinalby
       takze cala strone, zeby pokazac tor. Cel z offsetLeft konkretnej karty
       (pozycje()) - ta sama roznica pasuje do snapu start (telefon)
       i center (od 769px) i nie widzi transformu wcisniecia karty. */
    function doKarty(i, gladko) {
      var poz = pozycje(track);
      if (poz[i] === undefined) return;
      cel = i;
      celCzas = Date.now();
      track.scrollTo({
        left: poz[i],
        behavior: gladko && !reduced() ? 'smooth' : 'auto'
      });
    }

    if ('IntersectionObserver' in window) {
      /* Aktywna jest karta najbardziej widoczna w torze (najwyzszy
         intersectionRatio), a nie ostatnia z isIntersecting - przy powiekszeniu
         i na szerokich oknach sasiadki wystaja i tez sie przecinaja. */
      var widocznosc = slides.map(function () { return 0; });
      var patrzy = new IntersectionObserver(function (wpisy) {
        for (var i = 0; i < wpisy.length; i++) {
          var idx = slides.indexOf(wpisy[i].target);
          if (idx >= 0) widocznosc[idx] = wpisy[i].intersectionRatio;
        }
        var naj = 0;
        for (var k = 1; k < widocznosc.length; k++) {
          if (widocznosc[k] > widocznosc[naj]) naj = k;
        }
        if (widocznosc[naj] > 0) oznacz(naj);
      }, { root: track, threshold: [0, 0.25, 0.5, 0.75, 1] });
      for (var n = 0; n < slides.length; n++) patrzy.observe(slides[n]);
    }

    for (var k = 0; k < dots.length; k++) {
      (function (i) {
        dots[i].addEventListener('click', function () { doKarty(i, true); });
      })(k);
    }

    for (var h = 0; h < hits.length; h++) {
      (function (i) {
        hits[i].addEventListener('click', function () { doKarty(i, true); });
      })(h);
    }

    for (var b = 0; b < arrows.length; b++) {
      (function (btn) {
        var kier = Number(btn.getAttribute('data-aio6-arrow'));
        btn.addEventListener('click', function () {
          var to = Math.min(Math.max(baza() + kier, 0), slides.length - 1);
          doKarty(to, true);
        });
      })(arrows[b]);
    }

    /* Strzalki klawiatury przechodza po kropkach, Home i End skacza na
       skrajne - pigulka kropek zachowuje sie jak lista zakladek. */
    if (dots.length) {
      dots[0].parentNode.addEventListener('keydown', function (event) {
        var to = -1;
        if (event.key === 'ArrowRight') to = Math.min(baza() + 1, slides.length - 1);
        else if (event.key === 'ArrowLeft') to = Math.max(baza() - 1, 0);
        else if (event.key === 'Home') to = 0;
        else if (event.key === 'End') to = slides.length - 1;
        if (to < 0) return;
        event.preventDefault();
        doKarty(to, true);
        if (dots[to]) dots[to].focus();
      });
    }

    oznacz(0);
  }

  /* ZAKLADKI Z PANELEM MEDIOW
     Obsluguje kazdy pojemnik z atrybutem data-aio6-explore, wiec ten sam kod
     niesie eksplorator funkcji i wybor marki kamery sportowej.

     Zakladki w pelni w DOM: przelaczanie zmienia wylacznie aria i klasy,
     zadnych fetchow i zadnego wstrzykiwania tresci.

     Klawiatura wg wzorca listy zakladek: strzalki przechodza po zakladkach
     w kolko, Home i End skacza na skrajne. tabindex trzyma w tabulatorze
     tylko zakladke aktywna, zeby Tab wychodzil z listy, a nie brnal przez
     osiem przyciskow. */
  function explorer(scope) {
    var roots = scope.querySelectorAll('[data-aio6-explore]');
    for (var r = 0; r < roots.length; r++) zwiaz(roots[r]);

    function zwiaz(root) {
    var tabs = [].slice.call(root.querySelectorAll('[data-aio6-tab]'));
    if (!tabs.length) return;

    function select(index, moveFocus) {
      var chosen = tabs[index];
      if (!chosen) return;
      var key = chosen.getAttribute('data-aio6-tab');

      for (var i = 0; i < tabs.length; i++) {
        var active = tabs[i] === chosen;
        tabs[i].setAttribute('aria-selected', active ? 'true' : 'false');
        tabs[i].tabIndex = active ? 0 : -1;
      }

      /* Panelem bywa kadr marki (.aio6__panel) albo opis zakladki
         (data-aio6-panel) - oba przelaczaja sie tylko przez aria-hidden. */
      var panels = root.querySelectorAll('.aio6__panel, [data-aio6-panel]');
      for (var p = 0; p < panels.length; p++) {
        /* Panel opisu wiaze sie z zakladka przez aria-controls, kadr marki
           przez klucz w data-aio6-key. */
        var widoczny = panels[p].id === chosen.getAttribute('aria-controls') ||
          panels[p].getAttribute('data-aio6-key') === key;
        panels[p].setAttribute('aria-hidden', widoczny ? 'false' : 'true');
      }

      /* WARSTWY EKRANU URZADZENIA
         Nowa wchodzi przezroczystoscia, a dotychczasowa zostaje pod nia jako
         is-prev - bez tego w polowie przejscia widac by bylo ekran wdrukowany
         w ramke. Klase is-prev zdejmujemy z tej sprzed poprzedniej zmiany,
         czyli w kadrze sa najwyzej dwie widoczne warstwy naraz. */
      var ekrany = root.querySelectorAll('[data-aio6-screen]');
      if (ekrany.length) {
        var stara = root.querySelector('[data-aio6-screen].is-active');
        var przed = root.querySelector('[data-aio6-screen].is-prev');
        var nowa = null;
        for (var e = 0; e < ekrany.length; e++) {
          var czyTa = ekrany[e].getAttribute('data-aio6-screen') === key;
          ekrany[e].setAttribute('aria-hidden', czyTa ? 'false' : 'true');
          if (czyTa) nowa = ekrany[e];
        }
        if (nowa && nowa !== stara) {
          if (przed) przed.classList.remove('is-prev');
          if (stara) {
            stara.classList.remove('is-active');
            stara.classList.add('is-prev');
          }
          nowa.classList.remove('is-prev');
          nowa.classList.add('is-active');
        }
      }

      /* Dymek siedzi w li swojej pigulki, wiec razem z nim przelaczamy klase
         na samym li - to ona zmienia pigulke w bryle dymka (od 901px). Bez
         klasy musialby to robic selektor :has(), a ten nie wszedzie jeszcze
         jest. */
      var bubbles = root.querySelectorAll('[data-aio6-bubble]');
      for (var b = 0; b < bubbles.length; b++) {
        var open = bubbles[b].getAttribute('data-aio6-bubble') === key;
        bubbles[b].setAttribute('aria-hidden', open ? 'false' : 'true');
        var item = bubbles[b].parentElement;
        if (item) item.classList.toggle('is-open', open);
      }

      /* Wskaznik selektora segmentowego rusza w tej samej klatce co
         crossfade ekranu - zmienne ustawiamy synchronicznie z klasami. */
      suwak();

      /* Fokus przesuwamy tylko przy sterowaniu klawiatura. Po kliknieciu
         mysza zostaje tam, gdzie postawila go przegladarka. */
      if (moveFocus) chosen.focus();

      /* OPIS PONIZEJ 901px
         Dymek stoi pod lista pigulek, wiec po kliknieciu w dolnym rzedzie moze
         wypasc pod krawedz okna. Dosuwamy go tylko wtedy, gdy jego dolna
         krawedz jest poza oknem - inaczej strona nie drga. Odczyt po klatce,
         bo dymek dostaje swoj uklad dopiero z klasa is-open. */
      if (window.matchMedia && window.matchMedia('(max-width: 900px)').matches) {
        var otwarty = root.querySelector('[data-aio6-bubble="' + key + '"]');
        if (otwarty) {
          window.requestAnimationFrame(function () {
            var r = otwarty.getBoundingClientRect();
            if (r.bottom > window.innerHeight) {
              otwarty.scrollIntoView({ block: 'nearest', behavior: reduced() ? 'auto' : 'smooth' });
            }
          });
        }
      }
    }

    /* EKSPLORATOR PONIZEJ 769px
       Urzadzenie stoi zawsze na ekranie glownym, a pigulki sa zwyklymi
       przyciskami: kazda otwiera wspolna warstwe na swoim slajdzie.
       Od 769px wracaja role zakladek. Warstwa (urzadzenie z ekranami
       i karty z pelna nazwa i opisem) powstaje z tego samego DOM przy
       pierwszym otwarciu - tresc nie jest zdublowana w HTML. Pelna nazwa to aria-label pigulki
       (tekst z locales podany atrybutem). Odnosnik przypisu nie wchodzi do
       karty: kotwica prowadzilaby pod zamknieta warstwe. */
    var warstwaId = root.getAttribute('data-aio6-explore-layer');
    var mqTel = warstwaId && window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
    var listaZakladek = root.querySelector('[role="tablist"]');
    var ekranyPaneli = [].slice.call(root.querySelectorAll('[data-aio6-screen]'));
    var przyciski = false;

    function tryb() {
      var tel = !!(mqTel && mqTel.matches);
      if (tel === przyciski) return;
      przyciski = tel;
      if (tel) {
        var akt = root.querySelector('[data-aio6-tab][aria-selected="true"]');
        if (akt && tabs.indexOf(akt) !== 0) select(0, false);
      }
      if (listaZakladek) {
        if (tel) listaZakladek.removeAttribute('role');
        else listaZakladek.setAttribute('role', 'tablist');
      }
      for (var i = 0; i < tabs.length; i++) {
        var t = tabs[i];
        if (tel) {
          if (!t.hasAttribute('data-aio6-panel-id')) t.setAttribute('data-aio6-panel-id', t.getAttribute('aria-controls') || '');
          t.removeAttribute('role');
          t.removeAttribute('aria-selected');
          t.removeAttribute('tabindex');
          t.setAttribute('aria-haspopup', 'dialog');
          t.setAttribute('aria-controls', warstwaId);
        } else {
          t.setAttribute('role', 'tab');
          t.removeAttribute('aria-haspopup');
          t.setAttribute('aria-controls', t.getAttribute('data-aio6-panel-id') || '');
        }
      }
      for (var e = 0; e < ekranyPaneli.length; e++) {
        if (tel) ekranyPaneli[e].removeAttribute('role');
        else ekranyPaneli[e].setAttribute('role', 'tabpanel');
      }
      if (!tel) select(0, false);
    }

    function slajdyWarstwy(dlg) {
      var kontener = dlg.querySelector('[data-aio6-layer-slides]');
      if (!kontener || kontener.children.length) return;

      /* URZADZENIE: jedna ramka z bloku i warstwy ekranow w jej szkle,
         w tej samej kolejnosci co slajdy - warstwa() przelacza je razem ze
         slajdem (data-aio6-layer-screen). Dekoracja: opis niesie karta. */
      var ramkaBloku = root.querySelector('.aio6__device-frame');
      if (ramkaBloku) {
        var urzadzenie = document.createElement('div');
        urzadzenie.className = 'aio6__device aio6__xl-device';
        urzadzenie.setAttribute('data-aio6-layer-device', '');
        urzadzenie.setAttribute('aria-hidden', 'true');
        var ramka = document.createElement('img');
        ramka.className = 'aio6__device-frame';
        ramka.src = ramkaBloku.currentSrc || ramkaBloku.src;
        ramka.width = 2600;
        ramka.height = 1650;
        ramka.alt = '';
        ramka.decoding = 'async';
        urzadzenie.appendChild(ramka);
        var szklo = document.createElement('div');
        szklo.className = 'aio6__screen';
        for (var j = 0; j < tabs.length; j++) {
          var ekran = root.querySelector('[data-aio6-screen="' + tabs[j].getAttribute('data-aio6-tab') + '"]');
          var img = document.createElement('img');
          img.className = 'aio6__screen-layer';
          img.setAttribute('data-aio6-layer-screen', '');
          if (ekran) img.src = ekran.currentSrc || ekran.src;
          img.width = 1920;
          img.height = 1080;
          img.alt = '';
          img.decoding = 'async';
          szklo.appendChild(img);
        }
        urzadzenie.appendChild(szklo);
        kontener.appendChild(urzadzenie);
      }

      for (var i = 0; i < tabs.length; i++) {
        var key = tabs[i].getAttribute('data-aio6-tab');
        var opis = root.querySelector('[data-aio6-bubble="' + key + '"] .aio6__bubble-inner');
        var slajd = document.createElement('div');
        slajd.className = 'aio6__layer-slide';
        slajd.setAttribute('data-aio6-layer-slide', '');
        slajd.setAttribute('aria-hidden', 'true');

        var karta = document.createElement('div');
        karta.className = 'aio6__xl-card';
        var nazwa = document.createElement('p');
        nazwa.className = 'aio6__xl-name';
        nazwa.id = warstwaId + '-t-' + key;
        nazwa.setAttribute('data-aio6-layer-title', '');
        nazwa.textContent = tabs[i].getAttribute('aria-label') || '';
        karta.appendChild(nazwa);
        if (opis) {
          var kopia = opis.cloneNode(true);
          var zbedne = kopia.querySelectorAll('.aio6__fnref');
          for (var z = 0; z < zbedne.length; z++) zbedne[z].parentNode.removeChild(zbedne[z]);
          var zId = kopia.querySelectorAll('[id]');
          for (var d = 0; d < zId.length; d++) zId[d].removeAttribute('id');
          kopia.className = 'aio6__xl-text';
          karta.appendChild(kopia);
        }
        slajd.appendChild(karta);
        kontener.appendChild(slajd);
      }
    }

    if (mqTel) {
      tryb();
      if (mqTel.addEventListener) mqTel.addEventListener('change', tryb);
      else if (mqTel.addListener) mqTel.addListener(tryb);
    }

    root.addEventListener('click', function (event) {
      var tab = event.target.closest ? event.target.closest('[data-aio6-tab]') : null;
      if (!tab || !root.contains(tab)) return;
      if (przyciski) {
        var dlg = document.getElementById(warstwaId);
        if (!dlg || !dlg.aio6Otworz) return;
        slajdyWarstwy(dlg);
        dlg.aio6Otworz(tabs.indexOf(tab), tab);
        return;
      }
      select(tabs.indexOf(tab), false);
    });

    root.addEventListener('keydown', function (event) {
      if (przyciski) return;
      var tab = event.target.closest ? event.target.closest('[data-aio6-tab]') : null;
      if (!tab) return;

      var at = tabs.indexOf(tab);
      var to = -1;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        to = (at + 1) % tabs.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        to = (at - 1 + tabs.length) % tabs.length;
      } else if (event.key === 'Home') {
        to = 0;
      } else if (event.key === 'End') {
        to = tabs.length - 1;
      }

      if (to < 0) return;
      event.preventDefault();
      select(to, true);
    });

    /* STALA WYSOKOSC KOLUMNY PIGULEK (od 901px)

       Dymki nie sa rownej wysokosci: opisy maja rozna liczbe linii, wiec
       najdluzszy jest o kilkadziesiat pikseli wyzszy. Bez rezerwacji miejsca cala sekcja
       rosla przy jego otwarciu i wszystko pod nia przeskakiwalo.

       Rezerwe liczymy z DOM, a nie wpisujemy liczby w arkusz. Zwiniety dymek
       nie ma jeszcze swojego paddingu, wiec sam scrollHeight klamie o 30px -
       dlatego kazdy mierzymy w stanie otwartym i od razu wracamy do
       poprzedniego. To jeden przebieg przy starcie i przy zmianie szerokosci
       okna (zawijanie tekstu zmienia wynik), nie przy kazdym klikniecu. */
    var lista = root.querySelector('.aio6__pills');

    function rezerwuj() {
      if (!lista) return;
      lista.style.removeProperty('--aio6-pills-h');
      var otwarty = lista.querySelector('li.is-open .aio6__bubble-inner');
      var wysokoscOtwartego = otwarty ? otwarty.getBoundingClientRect().height : 0;
      var bazowa = lista.getBoundingClientRect().height - wysokoscOtwartego;

      var pozycje = lista.querySelectorAll('li');
      var najwyzszy = 0;
      for (var i = 0; i < pozycje.length; i++) {
        var wnetrze = pozycje[i].querySelector('.aio6__bubble-inner');
        if (!wnetrze) continue;
        var bylo = pozycje[i].classList.contains('is-open');
        if (!bylo) pozycje[i].classList.add('is-open');
        /* scrollHeight jest liczba zaokruglona w dol - przy wysokosci
           ulamkowej rezerwa wychodzila o ulamek piksela za niska i blok pod
           lista skakal; stad zapas 1px */
        var h = wnetrze.scrollHeight + 1;
        if (h > najwyzszy) najwyzszy = h;
        if (!bylo) pozycje[i].classList.remove('is-open');
      }
      if (!najwyzszy) return;

      lista.style.setProperty('--aio6-pills-h', Math.ceil(bazowa + najwyzszy) + 'px');
    }

    rezerwuj();
    window.addEventListener('resize', rezerwuj);

    /* WSKAZNIK SELEKTORA SEGMENTOWEGO
       Pozycja i szerokosc z faktycznej geometrii aktywnego pola, nie
       z ulamkow toru - etykiety EN i PL maja rozna dlugosc. Przy starcie,
       zmianie okna i po zaladowaniu fontow wskaznik staje na miejscu bez
       animacji: klasa is-ready (wlacza przejscie) wraca dopiero po odczycie
       ukladu. Animuje sie wylacznie zmiana wyboru. */
    var seg = root.querySelector('[data-aio6-seg]');

    function suwak() {
      if (!seg) return;
      var aktywne = seg.querySelector('[aria-selected="true"]');
      if (!aktywne) return;
      seg.style.setProperty('--aio6-seg-x', aktywne.offsetLeft + 'px');
      seg.style.setProperty('--aio6-seg-w', aktywne.offsetWidth + 'px');
    }

    function ustawBezRuchu() {
      if (!seg) return;
      seg.classList.remove('is-ready');
      suwak();
      void seg.offsetWidth;
      seg.classList.add('is-ready');
    }

    if (seg) {
      ustawBezRuchu();
      window.addEventListener('resize', ustawBezRuchu);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(ustawBezRuchu);
    }

    /* PRZESUNIECIE PALCEM
       Pojemnik z data-aio6-swipe zmienia zakladke gestem poziomym: co
       najmniej 40px w poziomie i wiecej w poziomie niz w pionie. W lewo =
       nastepna, w prawo = poprzednia, bez zawijania na koncach. Ramka nie
       ma wlasnego przewijania; touch-action: pan-y w arkuszu zostawia
       stronie pionowe przewijanie, a gest poziomy oddaje tu. */
    var strefa = root.querySelector('[data-aio6-swipe]');
    if (strefa) {
      var start = null;
      strefa.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        start = { x: event.clientX, y: event.clientY, id: event.pointerId };
      });
      strefa.addEventListener('pointerup', function (event) {
        if (!start || start.id !== event.pointerId) return;
        var dx = event.clientX - start.x;
        var dy = event.clientY - start.y;
        start = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
        var at = -1;
        for (var i = 0; i < tabs.length; i++) {
          if (tabs[i].getAttribute('aria-selected') === 'true') at = i;
        }
        var to = at + (dx < 0 ? 1 : -1);
        if (to >= 0 && to < tabs.length) select(to, false);
      });
      strefa.addEventListener('pointercancel', function () { start = null; });
    }
    }
  }

  /* KLIPY Z WLASNYM PRZYCISKIEM
     Film w kaflu stoi na pierwszej klatce, dopoki uzytkownik sam go nie
     uruchomi. Powod jest prosty: cztery petle grajace naraz w rzedzie
     przeciagaja uwage i zjadaja transfer, a tresc kazdego z nich niesie
     podpis pod kadrem.

     Jednoczesnie gra najwyzej jeden klip - uruchomienie kolejnego zatrzymuje
     poprzedni, tak samo jak zrobilby to natywny odtwarzacz. */
  function clips(scope) {
    var klipy = [].slice.call(scope.querySelectorAll('[data-aio6-clip]'));
    if (!klipy.length) return;

    function odswiez(btn, gra) {
      btn.setAttribute('aria-pressed', gra ? 'true' : 'false');
      btn.setAttribute('aria-label', btn.getAttribute(
        gra ? 'data-label-pause' : 'data-label-play'));
    }

    for (var i = 0; i < klipy.length; i++) {
      (function (video) {
        var btn = video.parentNode.querySelector('[data-aio6-clip-btn]');
        if (!btn) return;

        /* Safari czyta wyciszenie z wlasciwosci, nie z atrybutu - bez tego
           potrafi odmowic startu bez gestu, mimo ze gest wlasnie byl. */
        video.muted = true;

        video.addEventListener('play', function () { odswiez(btn, true); });
        video.addEventListener('pause', function () { odswiez(btn, false); });

        btn.addEventListener('click', function () {
          if (!video.paused) { video.pause(); return; }
          for (var k = 0; k < klipy.length; k++) {
            if (klipy[k] !== video) klipy[k].pause();
          }
          var ruszyl = video.play();
          if (ruszyl && ruszyl.catch) ruszyl.catch(function () {});
        });
      })(klipy[i]);
    }
  }

  /* WARSTWA PELNOEKRANOWA
     Jeden komponent dla wszystkich widokow na caly ekran (nagranie z kamer,
     ekrany eksploratora). Markup:
       <dialog data-aio6-layer id aria-modal="true" aria-labelledby>
         przycisk [data-aio6-layer-close],
         slajdy [data-aio6-layer-slide] - kazdy z tytulem [data-aio6-layer-title],
         opcjonalnie [data-aio6-layer-prev] / [data-aio6-layer-next].
     Otwiera go dowolny przycisk [data-aio6-layer-open="<id>"]
     z [data-aio6-layer-index], albo kod przez dialog.aio6Otworz(n, zrodlo).
     Parametr data-aio6-layer-nav wlacza strzalki, klawisze strzalek i swipe.
     Natywny dialog daje top-layer i Esc; fokus trzymamy dodatkowo sami (Tab
     nie wychodzi do paska przegladarki). Strona stoi na czas otwarcia: body
     position fixed z ujemnym top i kompensacja paska przewijania, po
     zamknieciu powrot bez animacji w to samo miejsce i fokus na zrodle.
     Film w slajdzie dostaje plik z data-src dopiero, gdy slajd jest aktywny,
     i staje (z cofnieciem) przy wyjsciu ze slajdu albo zamknieciu.
     Slajdy czytamy przy kazdym otwarciu, wiec wlasciciel moze je zbudowac
     tuz przed nim (eksplorator).
     Warstwy [data-aio6-layer-screen] przelaczaja sie razem ze slajdem
     o tym samym numerze (crossfade jak ekrany w bloku), a urzadzenie
     [data-aio6-layer-device] wchodzi i wychodzi krycie + skala (klasy
     is-otwarta / is-zamyka) - zamkniecie czeka wtedy na koniec przejscia. */
  function warstwa(scope) {
    var dialogi = scope.querySelectorAll('[data-aio6-layer]');
    for (var i = 0; i < dialogi.length; i++) {
      (function (dlg) {
        if (!dlg.showModal || dlg.hasAttribute('data-aio6-layer-on')) return;
        dlg.setAttribute('data-aio6-layer-on', '');
        var slajdy = dlg.querySelectorAll('[data-aio6-layer-slide]');
        var nawigacja = dlg.hasAttribute('data-aio6-layer-nav');
        var akt = -1;
        var pozycja = 0;
        var zrodlo = null;
        var zamyka = null;

        function ekrany(n) {
          var warstwy = dlg.querySelectorAll('[data-aio6-layer-screen]');
          var nowa = warstwy[n];
          if (!nowa || nowa.classList.contains('is-active')) return;
          var stara = dlg.querySelector('[data-aio6-layer-screen].is-active');
          var przed = dlg.querySelector('[data-aio6-layer-screen].is-prev');
          if (przed) przed.classList.remove('is-prev');
          if (stara) {
            stara.classList.remove('is-active');
            stara.classList.add('is-prev');
          }
          nowa.classList.add('is-active');
        }

        function zamknij() {
          var urzadzenie = dlg.querySelector('[data-aio6-layer-device]');
          if (!dlg.open) return;
          if (!urzadzenie || reduced()) { dlg.close(); return; }
          if (zamyka) return;
          dlg.classList.remove('is-otwarta');
          dlg.classList.add('is-zamyka');
          var czas = parseFloat(getComputedStyle(dlg).getPropertyValue('--aio6-dur')) || 320;
          zamyka = window.setTimeout(function () {
            zamyka = null;
            dlg.classList.remove('is-zamyka');
            dlg.close();
          }, czas);
        }

        function filmy(slajd, graj) {
          var v = slajd.querySelectorAll('video');
          for (var k = 0; k < v.length; k++) {
            if (graj) {
              if (!v[k].getAttribute('src') && v[k].getAttribute('data-src')) {
                v[k].setAttribute('src', v[k].getAttribute('data-src'));
              }
              var gra = v[k].play();
              if (gra && gra.catch) gra.catch(function () {});
            } else if (v[k].getAttribute('src')) {
              v[k].pause();
              try { v[k].currentTime = 0; } catch (e) { /* nic */ }
            }
          }
        }

        function pokaz(n) {
          if (!slajdy.length) return;
          /* Bez zapetlenia - na koncach warstwa stoi */
          n = Math.max(0, Math.min(n, slajdy.length - 1));
          for (var k = 0; k < slajdy.length; k++) {
            var on = k === n;
            slajdy[k].classList.toggle('is-active', on);
            slajdy[k].setAttribute('aria-hidden', on ? 'false' : 'true');
            if ('inert' in slajdy[k]) slajdy[k].inert = !on;
            if (!on && k === akt) filmy(slajdy[k], false);
          }
          var tytul = slajdy[n].querySelector('[data-aio6-layer-title]');
          if (tytul && tytul.id) dlg.setAttribute('aria-labelledby', tytul.id);
          ekrany(n);
          akt = n;
          if (dlg.open) filmy(slajdy[n], true);
          if (!nawigacja) return;
          /* Strzalka na krancu nieaktywna, wskaznik na biezacej funkcji.
             Fokus przenosimy przed wylaczeniem przycisku, inaczej spadlby na
             body poza modalnym dialogiem. */
          var ostatnia = n === slajdy.length - 1;
          if (dlg.open && wstecz && dalej) {
            if (n === 0 && document.activeElement === wstecz) dalej.focus();
            else if (ostatnia && document.activeElement === dalej) wstecz.focus();
          }
          if (wstecz) wstecz.disabled = n === 0;
          if (dalej) dalej.disabled = ostatnia;
          for (var m = 0; m < kropki.length; m++) kropki[m].classList.toggle('is-active', m === n);
        }

        function krok(d) {
          var n = akt + d;
          if (n < 0 || n >= slajdy.length) return;
          pokaz(n);
        }

        function otworz(n, skad) {
          /* slajdy moga powstac dopiero przed otwarciem (eksplorator) */
          slajdy = dlg.querySelectorAll('[data-aio6-layer-slide]');
          if (!slajdy.length) return;
          zrodlo = skad || document.activeElement;
          pozycja = window.scrollY;
          var pasek = window.innerWidth - document.documentElement.clientWidth;
          document.body.style.position = 'fixed';
          document.body.style.top = -pozycja + 'px';
          document.body.style.width = '100%';
          if (pasek > 0) document.body.style.paddingRight = pasek + 'px';
          dlg.classList.add('is-instant');
          dlg.classList.remove('is-otwarta', 'is-zamyka');
          pokaz(n || 0);
          dlg.showModal();
          filmy(slajdy[akt], true);
          /* stan poczatkowy urzadzenia musi byc policzony przed klasa wejscia,
             inaczej przejscie nie ma skad ruszyc */
          var urzadzenie = dlg.querySelector('[data-aio6-layer-device]');
          if (urzadzenie) void urzadzenie.offsetWidth;
          window.requestAnimationFrame(function () {
            dlg.classList.remove('is-instant');
            dlg.classList.add('is-otwarta');
          });
        }
        dlg.aio6Otworz = otworz;

        var otwieracze = scope.querySelectorAll('[data-aio6-layer-open]');
        for (var k = 0; k < otwieracze.length; k++) {
          (function (btn) {
            if (btn.getAttribute('data-aio6-layer-open') !== dlg.id) return;
            btn.addEventListener('click', function () {
              otworz(parseInt(btn.getAttribute('data-aio6-layer-index'), 10) || 0, btn);
            });
          })(otwieracze[k]);
        }

        var przyciskZamknij = dlg.querySelector('[data-aio6-layer-close]');
        if (przyciskZamknij) przyciskZamknij.addEventListener('click', zamknij);
        /* Esc zamyka natywnie (zdarzenie cancel) - przy urzadzeniu z przejsciem
           przejmujemy je, zeby wyjscie zagralo tak samo jak po kliknieciu. */
        dlg.addEventListener('cancel', function (e) {
          if (!dlg.querySelector('[data-aio6-layer-device]') || reduced()) return;
          e.preventDefault();
          zamknij();
        });
        var wstecz = dlg.querySelector('[data-aio6-layer-prev]');
        var dalej = dlg.querySelector('[data-aio6-layer-next]');
        var kropki = dlg.querySelectorAll('[data-aio6-layer-dots] > span');
        if (nawigacja && wstecz) wstecz.addEventListener('click', function () { krok(-1); });
        if (nawigacja && dalej) dalej.addEventListener('click', function () { krok(1); });

        dlg.addEventListener('keydown', function (e) {
          if (nawigacja && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
            if (document.activeElement && document.activeElement.tagName === 'VIDEO') return;
            e.preventDefault();
            krok(e.key === 'ArrowRight' ? 1 : -1);
            return;
          }
          if (e.key !== 'Tab') return;
          var cele = [].filter.call(dlg.querySelectorAll('button, [href], video[controls], [tabindex]:not([tabindex="-1"])'), function (el) {
            return !el.closest('[inert]') && !el.disabled && el.getClientRects().length;
          });
          if (!cele.length) return;
          var pierwszy = cele[0];
          var ostatni = cele[cele.length - 1];
          if (e.shiftKey && (document.activeElement === pierwszy || !dlg.contains(document.activeElement))) {
            e.preventDefault();
            ostatni.focus();
          } else if (!e.shiftKey && (document.activeElement === ostatni || !dlg.contains(document.activeElement))) {
            e.preventDefault();
            pierwszy.focus();
          }
        });

        if (nawigacja) {
          var x0 = null;
          var y0 = 0;
          dlg.addEventListener('pointerdown', function (e) {
            if (e.pointerType === 'mouse') return;
            x0 = e.clientX;
            y0 = e.clientY;
          });
          dlg.addEventListener('pointerup', function (e) {
            if (x0 === null) return;
            var dx = e.clientX - x0;
            var dy = e.clientY - y0;
            x0 = null;
            if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) krok(dx < 0 ? 1 : -1);
          });
          dlg.addEventListener('pointercancel', function () { x0 = null; });
        }

        dlg.addEventListener('close', function () {
          if (akt >= 0) filmy(slajdy[akt], false);
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
          document.body.style.paddingRight = '';
          var html = document.documentElement;
          var zach = html.style.scrollBehavior;
          html.style.scrollBehavior = 'auto';
          window.scrollTo(0, pozycja);
          html.style.scrollBehavior = zach;
          if (zrodlo && zrodlo.focus) zrodlo.focus({ preventScroll: true });
        });
      })(dialogi[i]);
    }
  }

  /* WSKAZNIK POZYCJI TORU
     Wskaznik stoi zaraz za swoim torem. Aktywna kreska to karta najblizsza
     lewej krawedzi przewijania (scroll-padding), a na koncu toru ostatnia.
     Odczyt w klatce animacji, tylko przy przewijaniu toru i zmianie okna. */
  function pager(scope) {
    var wskazniki = scope.querySelectorAll('[data-aio6-pager]');
    for (var i = 0; i < wskazniki.length; i++) {
      (function (wsk) {
        if (wsk.hasAttribute('data-aio6-pager-on')) return;
        var tor = wsk.previousElementSibling;
        if (!tor) return;
        wsk.setAttribute('data-aio6-pager-on', '');
        var kreski = wsk.children;
        var czeka = false;

        function licz() {
          czeka = false;
          var karty = tor.children;
          if (!karty.length) return;
          var styl = window.getComputedStyle(tor);
          var start = tor.getBoundingClientRect().left + (parseFloat(styl.scrollPaddingLeft) || parseFloat(styl.paddingLeft) || 0);
          var akt = 0;
          if (tor.scrollLeft >= tor.scrollWidth - tor.clientWidth - 2) {
            akt = karty.length - 1;
          } else {
            var min = Infinity;
            for (var k = 0; k < karty.length; k++) {
              var d = Math.abs(karty[k].getBoundingClientRect().left - start);
              if (d < min) { min = d; akt = k; }
            }
          }
          for (var n = 0; n < kreski.length; n++) kreski[n].classList.toggle('is-active', n === akt);
        }

        function zamow() {
          if (czeka) return;
          czeka = true;
          window.requestAnimationFrame(licz);
        }

        tor.addEventListener('scroll', zamow, { passive: true });
        window.addEventListener('resize', zamow);
        licz();
      })(wskazniki[i]);
    }
  }

  /* KARUZELE RUSZAJA SAME, RAZ
     Tory z data-aio6-auto (karty przegladu, kafle kamer, Kupujesz w Polsce).
     - start 1,2 s po wejsciu toru w widok, potem jedna karta co 5 s, plynnie;
     - pauza, gdy tor wyjdzie z widoku albo dokument jest w tle (wraca sam);
     - trwale zatrzymanie przy pierwszym dotyku, kliknieciu, przewinieciu
       palcem, fokusie klawiatury albo kursorze nad torem - do konca wizyty;
     - bez zapetlenia: staje na ostatniej karcie;
     - przy ograniczeniu ruchu nie rusza wcale; tor bez czego przewijac tez.
     Przewiniecie skryptowe oznaczamy flaga, zeby jego zdarzenia scroll nie
     liczyly sie jako ruch uzytkownika. */
  var AUTO_START = 1200;
  var AUTO_KROK = 5000;

  function autoplay(scope) {
    if (reduced() || !('IntersectionObserver' in window)) return;
    var tory = scope.querySelectorAll('[data-aio6-auto]');
    for (var i = 0; i < tory.length; i++) {
      (function (tor) {
        if (tor.hasAttribute('data-aio6-auto-on')) return;
        tor.setAttribute('data-aio6-auto-on', '');
        var koniec = false;
        var widoczny = false;
        var timer = null;
        var skrypt = false;
        var flagaTimer = null;

        function stop() {
          koniec = true;
          window.clearTimeout(timer);
          tor.setAttribute('data-aio6-auto-on', 'stop');
        }

        function planuj(ms) {
          window.clearTimeout(timer);
          if (koniec || !widoczny || document.hidden) return;
          timer = window.setTimeout(nastepna, ms);
        }

        function nastepna() {
          if (koniec || !widoczny || document.hidden) return;
          var max = tor.scrollWidth - tor.clientWidth;
          if (max <= 1 || tor.scrollLeft >= max - 2) { stop(); return; }
          skrypt = true;
          window.clearTimeout(flagaTimer);
          flagaTimer = window.setTimeout(function () { skrypt = false; }, 1000);
          /* Nastepna karta z jej pozycji, nie z sumy szerokosci */
          var poz = pozycje(tor);
          tor.scrollTo({ left: poz[Math.min(najblizsza(tor, poz) + 1, poz.length - 1)], behavior: 'smooth' });
          planuj(AUTO_KROK);
        }

        var obs = new IntersectionObserver(function (wpisy) {
          widoczny = wpisy[0].isIntersecting;
          if (widoczny) planuj(AUTO_START); else window.clearTimeout(timer);
        }, { threshold: 0.5 });
        obs.observe(tor);

        document.addEventListener('visibilitychange', function () {
          if (document.hidden) window.clearTimeout(timer); else planuj(AUTO_KROK);
        });

        ['pointerdown', 'touchstart', 'wheel', 'focusin', 'keydown'].forEach(function (typ) {
          tor.addEventListener(typ, stop, { passive: true });
        });
        tor.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') stop(); });
        tor.addEventListener('scroll', function () { if (!skrypt) stop(); }, { passive: true });

        /* kropki i strzalki karuzeli to tez interakcja z torem */
        var blok = tor.closest('.aio6__block');
        if (blok) {
          var sterowanie = blok.querySelectorAll('[data-aio6-dot], [data-aio6-arrow], [data-aio6-tiles-arrow]');
          for (var k = 0; k < sterowanie.length; k++) sterowanie[k].addEventListener('click', stop);
        }
      })(tory[i]);
    }
  }

  function initAll(root) {
    var scopes = (root || document).querySelectorAll('.aio6');
    for (var i = 0; i < scopes.length; i++) {
      reveal(scopes[i]);
      parallax(scopes[i]);
      carousel(scopes[i]);
      tiles(scopes[i]);
      drag(scopes[i]);
      nacisk(scopes[i]);
      notes(scopes[i]);
      clips(scopes[i]);
      explorer(scopes[i]);
      warstwa(scopes[i]);
      pager(scopes[i]);
      autoplay(scopes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  if (window.__aio6Init) return;
  window.__aio6Init = true;

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
